if(!customElements.get('jump-link')) {
  class JumpLink extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('readystatechange', () => {
        this.elButton = this.querySelector('a');
        this.elSection = document.getElementById(this.elButton.href.split('#')[1]);

        this.observer = new IntersectionObserver(this.toggleVisibility.bind(this));
        this.elSection && this.observer.observe(this.elSection);
      })
    }

    toggleVisibility([entry], observer) {
      this.classList.toggle('in-view', entry.isIntersecting || entry.boundingClientRect.y < 0);
    }
  }

  customElements.define('jump-link', JumpLink);
}